module.exports = __webpack_public_path__ + "media/images/promo/championship/digits/2-e637c3a50c5992c4b2fb1c8f68dbd965.png";